import { render, staticRenderFns } from "./paging.vue?vue&type=template&id=03da52c8&"
import script from "./paging.vue?vue&type=script&lang=js&"
export * from "./paging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports